import { HttpClient, HttpEvent, HttpRequest } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "apps/website/src/environments/environment";
import { Observable } from "rxjs";
import { CommonWebService, CreateDocuments, DEVICE_CREDENTIALS, DocumentDetail, DocumentsList, HttpResponse, RenameFileFolder, ShareFileFolder, UploadFile, UserHttpService } from "../public-api";

@Injectable({
  providedIn: "root",
})
export class ManageDocumentService {

    constructor(
        private http: HttpClient,
        private commonService: CommonWebService,
        private userService: UserHttpService
    ) {}

    public createDocument(body: CreateDocuments): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("folderName", body.folderName ? body.folderName : '');  
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  

        if(body.pId) {
            formData.append("pId", body.pId ? body.pId : '');
        }

        if(body.project_id) {
            formData.append("project_id", body.project_id ? body.project_id : '');
        }

        return this.http.post<HttpResponse<any>>('dms/createFolder', formData);
    }

    public renameFileFolder(body: RenameFileFolder) : Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("editFileFolderName", body.editFileFolderName ? body.editFileFolderName : '');  
        formData.append("editFileFolderId", body.editFileFolderId ? body.editFileFolderId : '');  
        formData.append("pId", body.pId ? body.pId : '0');  
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  

        return this.http.post<HttpResponse<any>>('dms/renameFileFolder', formData);
    }

    public documentsList(pId?: string, isSharedWithMe: boolean = false): Observable<HttpResponse<DocumentsList[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  

        if(pId) {
            formData.append("id", pId ? pId : '');
        }

        return this.http.post<HttpResponse<DocumentsList[]>>(isSharedWithMe ? 'dms/fileSharedWithMe' : 'dms/myFolders', formData);
    }

    public uploadDocuments(file: any, pId: string): Observable<HttpResponse<DocumentsList[]>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("file", file ? file : "");
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  

        if(pId) {
            formData.append("pId", pId ? pId : '');
        }

        return this.http.post<HttpResponse<DocumentsList[]>>('dms/uploadFile', formData);
    }

    public uploadFolderFiles(file: any, isDrag: boolean = false, pId: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("file", file ? file : "");
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  
     
        if(pId) {
            formData.append("pId", pId ? pId : "");
        }

        if(isDrag) {
            formData.append("path", file && file.relativePath ? file.relativePath : "");
        } else {
            formData.append("path", file && file.webkitRelativePath ? file.webkitRelativePath : "");
        };
        return this.http.post<HttpResponse<any>>('dms/createFolderWithFiles', formData);
    }

    public shareFileFolder(body: ShareFileFolder): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  

        formData.append("folderId", body.folderId ? body.folderId : "");
        formData.append("shareto", body.shareto ? this.commonService.changeDateFormat(body.shareto as Date) : "");
        formData.append("tagsList", body.tagsList && body.tagsList.length > 0 ? JSON.stringify(body.tagsList) : "");

        if(body.notifyPeople) {
            formData.append("notifyPeople", "1");
        }

        formData.append("token", this.userService.userToken);
        return this.http.post<HttpResponse<any>>('dms/shareFileFolder', formData);
    }

    public documentDetails(pId: string): Observable<DocumentDetail> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("pId", pId ? pId : "");
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  
        return this.http.post<DocumentDetail>('dms/getFileDetails', formData);
    }


    public deleteFileFolder(id: string, userid: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("pId", id ? id : "");
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  
        formData.append("type", this.userService.getUserInfo.user_id == userid ? "own" : "share");
        return this.http.post<HttpResponse<any>>('dms/deleteFileFolder', formData);
    }


    public addToBookmark(id: string, userid: string): Observable<HttpResponse<any>> {
        let formData = new FormData();
        formData.append("user_id", this.userService.getUserInfo.user_id);
        formData.append("usr_role_track_id", this.userService.getUserInfo.usr_role_track_id);
        formData.append("customer_id", this.userService.getUserInfo.usr_customer_track_id);
        formData.append("token", this.userService.userToken);
        formData.append("pId", id ? id : "");
        formData.append("deviceType", DEVICE_CREDENTIALS.DEVICE_TYPE);  
        formData.append("deviceToken", DEVICE_CREDENTIALS.DEVICE_TOKEN);  
        formData.append("type", this.userService.getUserInfo.user_id == userid ? "own" : "share");
        return this.http.post<HttpResponse<any>>('dms/bookmark', formData);
    }

    public downloadFile(id: string) {
        let url = `${environment.baseUrl}dms/download/${id}/${this.userService.getUserInfo.user_id}`;
        return url.toString();
    }
}
